module.exports = __webpack_public_path__ + "img/icon_kefu.f5fc6b96.png";